// extracted by mini-css-extract-plugin
module.exports = {"green":"#5bc1a4","whyUsBriefColor":"#838282","offerCallNumber":"#006336","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282"};